var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"role":"main"}},[_c('h1',[_vm._v("Get matrix")]),_c('artist-and-song-form',{on:{"change":function (ref) {
var searchTerm = ref.searchTerm;
var results = ref.results;
 this$1.searchTerm = searchTerm; this$1.results = results; }},model:{value:(_vm.results),callback:function ($$v) {_vm.results=$$v},expression:"results"}}),_c('matrix-results-viewer',{attrs:{"results":_vm.results,"search-term":_vm.searchTerm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }